import {createRouter, createWebHistory} from "vue-router/dist/vue-router";

import routerProject from "@/routers/RouterProject";
import routerAdministrator from "@/routers/RouterAdministrator";
import RouterError from "@/routers/RouterError";


let baseRouter = routerProject.concat(routerAdministrator, RouterError);

let router = createRouter({
    history: createWebHistory(),
    routes: baseRouter
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
})

export default router;